"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/SelectedItemsList/index"), exports);
//# sourceMappingURL=SelectedItemsList.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/SelectedItemsList.js
// module id = 1447
// module chunks = 0